import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { styles } from "../CsStyles";

import Autocomplete from "@material-ui/lab/Autocomplete";
import { GenericFieldNames } from "../../Constants";
import { Box, Grid, IconButton, TextField, Typography } from '@material-ui/core';

import { Delete, ArrowUpward, ArrowDownward, Settings, Add, Remove } from '@material-ui/icons';

class AttributeList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            value: ""
        };
    }
    
    render() {
        return (
            <React.Fragment>
                <Box
                    style={{
                        border: "1px solid #000",
                        padding: "10px",
                        width: "100%",
                        margin: '1em',
                        background: '#DDDDDD'
                    }}>
                    Attributes:
                    {
                        this.props.attributes.map((e, i) =>
                            <Attribute name={e.name} value={e.value} num={i} remove={this.props.funcs.remove} update={this.props.funcs.update} />
                        )
                    }

                    <Box
                        style={{
                            border: "1px solid #000",
                            padding: "10px",
                            margin: '1em',
                            background: '#FFFFFF'
                        }}>
                        <TextField onChange={e => this.setState({ name: e.target.value })} value={this.state.name} style={{ "margin-right": '1em' }} />

                        <TextField onChange={e => this.setState({ value: e.target.value })} value={this.state.value} style={{ "margin-right": '1em' }} />

                        <IconButton color="primary" aria-label="delete" component="span" style={{ "position": "relative", "float": "right", "vertical-align": "middle" }}>
                            <Add onClick={() => {
                                this.props.funcs.add(this.state.name, this.state.value);
                                this.setState({ name: "", value: "" });
                            }} />
                        </IconButton>
                    </Box>
                </Box>
            </React.Fragment>
        );
    }
}

class Attribute extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Box
                    style={{
                        border: "1px solid #000",
                        padding: "10px",
                        margin: '1em',
                        background: '#FFFFFF'
                    }}>
                    <TextField value={this.props.name} style={{ "margin-right": '1em' }} onChange={e => this.props.update(this.props.num, { name: e.target.value })} />

                    <TextField value={this.props.value} style={{ "margin-right": '1em' }} onChange={e => this.props.update(this.props.num, { value: e.target.value })} />

                    <IconButton color="primary" aria-label="delete" component="span" style={{ "position": "relative", "float": "right", "vertical-align": "middle" }}>
                        <Remove onClick={() => this.props.remove(this.props.num)} />
                    </IconButton>
                </Box>
            </React.Fragment>
        );
    }
}

export default withStyles(styles)(AttributeList);